import GroupFolderAction from './GroupFolderAction';
import { getEndpointUrl } from './getEndpointUrl';
import getHttpMethodForGroupFolderAction from './getHttpMethodForGroupFolderAction';
import { HttpConstants } from './httpConstants';

const shouldAddRequestHeaderContentType: Map<GroupFolderAction, boolean> = new Map([
    [GroupFolderAction.CreateFolder, true],
    [GroupFolderAction.RenameFolder, true],
    [GroupFolderAction.CopyFolder, true],
    [GroupFolderAction.MoveFolder, true],
]);

export default function getRequestWithHeader(
    accessToken: string,
    action: GroupFolderAction,
    groupId: string,
    folderId: string
) {
    const request = new XMLHttpRequest();
    const url: string = getEndpointUrl(action, groupId, folderId);
    const httpMethod = getHttpMethodForGroupFolderAction(action);
    request.open(httpMethod, url, true /*async*/);

    request.setRequestHeader(
        HttpConstants.AuthorizationTag,
        HttpConstants.BearerTokenHeader + accessToken
    );
    request.setRequestHeader(HttpConstants.XAnchorMailbox, groupId);

    if (shouldAddRequestHeaderContentType.get(action)) {
        request.setRequestHeader(HttpConstants.ContentTypeHeader, HttpConstants.ContentTypeValue);
    }

    return request;
}
